import "core-js/modules/es.regexp.escape.js"